import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { ToasterService } from '../services/toastr.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private _authService: AuthService,
    private _toastrService: ToasterService,
    private translateService: TranslateService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    if (state.url.includes('/auth/login')) {
      if (this._authService.isAuthenticated()) {
        this.router.navigate(['/dashboard']);
        return false;
      } else {
        return true;
      }
    } else {
      if (!this._authService.isAuthenticated()) {
        this.router.navigate(['/auth/login']);
        this._toastrService.errToastr(
          this.translateService.instant('LoginFirst')
        );
        return false;
      } else {
        return true;
      }

    }

  }
}

